export { OfficerPage as default } from '@/components/pages/Company/Officer'
